// libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

// Components
import CardSlider from '../../cards/cardSlider/CardSlider';
import LinedTitle from '../../tools/linedTitle/LinedTitle';

// Props and Context
const propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string,
  title: PropTypes.string,
};
const defaultProps = {
  description: null,
  title: null,
};
const contextTypes = {
  t: PropTypes.func,
};

function RelatedContent({ children, description, title }) {
  return (
    <div className="section section--grey">
      <div className="section__wrapper">
        {title &&
          <LinedTitle
            title={title}
            description={description}
          />
        }
        <CardSlider>
          {children}
        </CardSlider>
      </div>
    </div>
  );
}

RelatedContent.contextTypes = contextTypes;
RelatedContent.propTypes = propTypes;
RelatedContent.defaultProps = defaultProps;

export default withRouter(RelatedContent);



// WEBPACK FOOTER //
// ./src/app/components/singles/parts/RelatedContent.js